<template lang="html">
  <div class="login h-screen bg-gray-200">
    <div class="container mx-auto">
      <h1
        v-if="state != 'new'"
        class="text-center block w-full py-12 text-3xl text-orange-500 font-semibold"
      >
        Welcome to Push
        <span class="text-xs text-push-gray mx-auto table"
          >powered by <span><img class="w-10 block mx-auto" :src="hh"/></span
        ></span>
      </h1>
      <div class="w-full md:w-1/2 px-4 mx-auto">
        <span
          class="text-center block w-full py-12 text-3xl text-orange-500 font-semibold"
          v-if="state == 'new'"
        >
          Register
        </span>
        <form @submit.prevent="login">
          <div class="bg-red-600 text-white p-4 border rounded" v-if="error">
            <span>{{ error }}</span>
          </div>
          <!-- Email Section  -->
          <div v-if="state == 'email'" class="mt-4">
            <label v-if="state == 'email'"><b>Enter your email*</b></label>
            <input
              @keyup.enter="next"
              class="bg-white p-3 rounded w-full mt-4"
              placeholder="Your email"
              name="email"
              label="Mail"
              id="email"
              v-model="form.email"
              type="email"
              required
            />
          </div>
          <!-- Full Name Field -->
          <div class="mt-4 relative" v-if="state == 'new'">
            <label><b>Full Name*</b></label>
            <input
              @keyup.enter="login"
              class="bg-white p-3 rounded w-full mt-4"
              placeholder="Your Full Name"
              name="Name"
              label="Name"
              id="Name"
              v-model="form.Name"
              required
            />
          </div>
          <!-- Main Password Field -->
          <div
            class="mt-4 relative"
            v-if="state == 'password' || state == 'new'"
          >
            <label><b>Password*</b></label>
            <span class="relative block">
              <input
                @keyup.enter="login"
                class="bg-white p-3 rounded w-full mt-4"
                placeholder="Your password"
                name="password"
                :type="revealpw"
                label="Password"
                id="password"
                v-model="form.password"
                required
              />
              <!-- Reveal Password -->
              <a
                v-if="revealpw == 'password'"
                @click="revealpw = 'text'"
                class="absolute text-gray-500 right-0 top-0 mt-5 text-3xl mr-3"
              >
                <i class="fas fa-eye-slash"></i>
              </a>

              <a
                v-if="revealpw == 'text'"
                @click="revealpw = 'password'"
                class="absolute text-gray-500 right-0 top-0 mt-5 text-3xl mr-3"
              >
                <i class="fas fa-eye"></i>
              </a>
            </span>
          </div>
          <!-- New/Confirm Password Field -->
          <div class="mt-4" v-if="state == 'new'">
            <label for="confirmpassword"><b>Confirm Password*</b></label>
            <span class="relative block">
              <input
                @keyup.enter="createUser"
                class="bg-white p-3 rounded w-full mt-4"
                placeholder="Your password"
                name="confirmpassword"
                label="Password"
                id="confirmpassword"
                v-model="form.confirmPassword"
                :type="revealpw"
                required
              />
              <!-- Reveal Password -->
              <a
                v-if="revealpw == 'password'"
                @click="revealpw = 'text'"
                class="absolute text-gray-500 right-0 top-0 mt-5 text-3xl mr-3"
              >
                <i class="fas fa-eye-slash"></i>
              </a>

              <a
                v-if="revealpw == 'text'"
                @click="revealpw = 'password'"
                class="absolute text-gray-500 right-0 top-0 mt-5 text-3xl mr-3"
              >
                <i class="fas fa-eye"></i>
              </a>
            </span>
          </div>
          <!-- Comapny Field -->
          <div class="mt-4 relative" v-if="state == 'new'">
            <label for="company"><b>Company</b></label>
            <input
              @keyup.enter="login"
              class="bg-white p-3 rounded w-full mt-4"
              placeholder="Your Company"
              name="company"
              label="company"
              id="company"
              v-model="form.company"
              required
            />
          </div>
          <!-- emailTerms Field -->
          <div class="mt-4 relative flex" v-if="state == 'new'">
            <label for="emailTerms" class="flex">
              <input
                class="mr-2 flex"
                type="checkbox"
                id="checkbox"
                v-model="form.emailTerms"
              />
              <p>
                Help us improve our products and keep you informed of new
                exciting features by signing up to our newsletter. We promise to
                send you only relevant information and not clog up your inbox
                with excessive unnecessary emails!
              </p>
            </label>
          </div>
          <div v-if="state == 'email'" class="mt-8 text-center">
            <button
              @click.prevent="next"
              class="py-3 text-white px-16 bg-push-blue"
              type="submit"
            >
              Next
            </button>
          </div>
          <div v-if="state == 'password'" class="mt-8 text-center">
            <button
              @click.prevent="login"
              class="py-3 text-white px-16 bg-push-blue"
              type="submit"
            >
              Login
            </button>
          </div>
          <div v-if="state == 'new'" class="mt-8 text-center">
            <button
              @click="createUser"
              class="py-3 text-white px-16 bg-push-blue"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
export default {
  name: "login",
  data() {
    return {
      hh:
        "https://handhcomms.co.uk/wp-content/uploads/2018/09/handhlogosmall.png",
      state: "email",
      error: null,
      revealpw: "password",
      form: {
        Name: "",
        email: "",
        password: "",
        confirmPassword: "",
        company: "",
        emailTerms: null
      }
    };
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$router.replace({ name: "home" });
      } else {
        this.loading = false;
      }
    });
  },
  methods: {
    login() {
      var vm = this;
      if (!vm.form.password) {
        vm.error = vm.language.passwordLabel;
        return;
      }
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then(data => {
          if (data) {
            vm.$router.replace({ name: "home" });
          }
        })
        .catch(function(error) {
          // Handle Errors here.
          //this.error = error.code;
          vm.error = error.message;
          setTimeout(function() {
            vm.error = null;
          }, 3000);
        });
    },
    createUser() {
      if (this.form.password === this.form.confirmPassword) {
        var vm = this;
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.form.email, this.form.password)
          .then(data => {
            data.user
              .updateProfile({
                displayName: this.form.name
              })
              .then(() => {
                var firestore = firebase.firestore();
                const uid = firebase.auth().currentUser.uid;
                var userRef = firestore.collection("users").doc(String(uid));
                userRef.set({
                  name: this.form.Name,
                  email: this.form.email,
                  company: this.form.company,
                  emailTerms: null,
                  profile: []
                });
              });
            vm.state = "profile";
          })
          .catch(err => {
            vm.error = err.message;
          });
      } else {
        this.error =
          "Make sure your passwords match and your email address is valid";
        setTimeout(function() {
          this.error = null;
        }, 3000);
      }
    },
    next() {
      var vm = this;

      if (!this.form.email) {
        this.error = "Please enter an email address";
        return;
      }
      // Check email exists
      firebase
        .auth()
        .fetchSignInMethodsForEmail(this.form.email)
        .then(data => {
          vm.state = data[0];
          if (!data.length) {
            vm.state = "new";
          }
          console.log(data[0]);
        })
        .catch(err => {
          vm.error = err.message;
        });
    }
  }
};
</script>

<style lang="css"></style>
